import React, { useEffect, useState, useContext } from "react";
// import { CiSearch } from "react-icons/ci";
import ResetDeactivate from "./ResetDeactivate";
import { AppContext } from "../../Context/Context";
import toast, { Toaster } from "react-hot-toast";
import {
  fetch_users_data,
  getUserLogs,
} from "../../Api";

function UserTable() {
  const {
    user,
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
    setCount,
    setMapModal,
    setActivityLogs
  } = useContext(AppContext);


  const [userData, setUserData] = useState([]);
  const [error,setError]=useState(null);

  const fetchData = async () => {
    setError(null);
    let {success,data,error} = await fetch_users_data(user?.clientName , page, rowsPerPage,user?.token);
    if(success){
      setUserData(data.data);
      setCount(data.totalDocuments);
    }else{
      setError(error);
    }
  };

  useEffect(() => {
      fetchData();
  }, [page, rowsPerPage]);

  const handleActivityLogs = async (userid) => {
    let {success,data,error} = await getUserLogs(userid,user?.token);
    if(success){
      setActivityLogs(data);
      if(data?.length){
        setMapModal(true);
      }
    }else{
      toast.error(error)
    }
  };


  if (error) {
    return <div className="p-2 mx-auto w-fit">Error: {error}</div>;
  }

  return (
    <div className="w-full m-auto mt-3 flex flex-col justify-center items-start px-5">
      <Toaster position="top-center" reverseOrder={false} />
      <div
        className="shadow
      flex justify-center items-center 
      w-full py-2"
      >
        {/* <div className=" basis-1/3"> */}
        {/* <SideNavbar/> */}
        {/* </div> */}
        <div className="basis-1/3  text-sm font-medium text-center underline col-start-2 underline-offset-4 decoration-slate-800">
          Manage My Users
        </div>
      </div>
      <div className="w-[100%] m-auto mt-3 flex flex-col justify-center  items-start ">
        <div className="w-full flex items-start justify-center">
          <div className="w-full h-[400px] overflow-y-auto overflow-x-hidden">
            <table
              className={`w-full table-auto  bg-white ${
                userData.length ? "shadow-md" : ""
              } rounded-xl`}
            >
              <thead className="sticky top-0 ">
                <tr
                  className={`${
                    !userData.length ? "flex justify-evenly" : ""
                  } text-[13px] text-white bg-[#0091ac]`}
                >
                  <th className="py-2 px-2 text-left ">SNo</th>
                  {/* <th className="py-2 px-2 text-left ">
                    <div className="flex items-center justify-start gap-2">
                      User ID{" "}
                    </div>{" "}
                  </th> */}
                  <th className="py-2 px-2 text-left ">
                    <div className="flex items-center justify-start  ">
                      Name
                    </div>
                  </th>
                  <th className="py-2 px-2 text-left ">
                    <div className="flex items-center justify-start  ">
                      E-mail
                    </div>
                  </th>
                  {/* <th className="py-2 px-2 text-left ">
                    <div className="flex items-center justify-start  ">
                      Phone Number
                    </div>
                  </th> */}
                  <th className="py-2 px-2 text-left ">Status</th>
                  <th className="py-2 px-2 text-center ">Actions</th>
                </tr>
              </thead>

              <tbody className="text-[13px] text-blue-gray-900 ">
                {userData?.map((element, index) => (
                  <tr
                    className={`${
                      index % 2 === 1 ? "bg-[#cff7ff]" : "bg-[#e7fbff]"
                    } cursor-pointer hover:bg-[#88f0fa]`}
                    key={index}
                  >
                    <td className="text-left py-2 px-2">
                      {index + 1 + page * rowsPerPage}
                    </td>
                    {/* <td className="text-left py-2 px-2">{element.userId}</td> */}
                    {/* <td className="text-left py-2 px-2">{element.State}</td> */}
                    <td className="text-left py-2 px-2">{element.userName}</td>
                    <td className="text-left py-2 px-2">{element.email}</td>
                    {/* <td className="text-left py-2 px-2">{element.phone}</td> */}
                    <td className="text-left py-2 px-2">
                      {element.status === "Active" ? (
                        <span className="text-green-900 font-bold">Active</span>
                      ) : (
                        <span className="text-red-700 font-bold">Deactive</span>
                      )}
                    </td>
                    <td className="py-2 px-2">
                      <div className="flex justify-center text-center">
                        {/* <div
                          // onClick={() => handleImgview(element)}
                          className="    pr-2 cursor-pointer border-r  border-black   "
                        >
                          <span className="transition-all inline-block text-sky-700 underline hover:text-sky-900 hover:scale-110">
                            <AddEditUser modalType={"Edit"} />
                          </span>
                        </div> */}
                        <div
                          onClick={() => handleActivityLogs(element._id)}
                          className=" px-2 cursor-pointer border-r border-black   "
                        >
                          <span className=" transition-all inline-block text-sky-700 underline hover:text-sky-900 hover:scale-110">
                            {" "}
                            Activity Logs{" "}
                          </span>
                        </div>
                        {/* <div className=" px-2 cursor-pointer border-r border-black   ">
                          <span className=" transition-all inline-block text-sky-700 underline hover:text-sky-900 hover:scale-110">
                            {" "}
                            <ResetDeactivate
                              modalType={"Reset Password"}
                            />{" "}
                          </span>
                        </div> */}
                        <div className=" px-2 cursor-pointer  ">
                          <span className=" transition-all inline-block text-sky-700 underline hover:text-sky-900 hover:scale-110">
                            {" "}
                            <ResetDeactivate
                              modalType={element.status === "Active" ? "Deactivate" : "Activate"}
                              user={element}
                              refreshData={fetchData}
                              token={user?.token}
                            />{" "}
                          </span>
                        </div>
                        {/* </button> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserTable;
